import { Icon } from '@adobe/react-spectrum';

const LeftSidebarCloseIcon = props => {
  return (
    <Icon {...props}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
      >
        <path
          d="M10 9.24971H6.72522L7.64746 8.26143C7.93066 7.9587 7.91406 7.48409 7.61133 7.20088C7.30957 6.91963 6.83399 6.93526 6.55176 7.23799L4.45215 9.48799C4.18262 9.77608 4.18262 10.2233 4.45215 10.5114L6.55176 12.7614C6.69922 12.9196 6.89942 12.9997 7.09961 12.9997C7.2832 12.9997 7.4668 12.9333 7.61133 12.7985C7.91406 12.5153 7.93067 12.0407 7.64746 11.738L6.72522 10.7497H10V9.24971Z"
          fill="#0265DC"
        />
        <path
          d="M15.75 2H4.25C3.00977 2 2 3.00977 2 4.25V15.75C2 16.9902 3.00977 18 4.25 18H15.75C16.9902 18 18 16.9902 18 15.75V4.25C18 3.00977 16.9902 2 15.75 2ZM3.5 15.75V4.25C3.5 3.83691 3.83691 3.5 4.25 3.5H10V9.25H13.2748L12.3525 8.26172C12.0693 7.95899 12.0859 7.48438 12.3887 7.20117C12.6904 6.91992 13.165 6.93555 13.4482 7.23828L15.5478 9.48828C15.8174 9.77637 15.8174 10.2236 15.5478 10.5117L13.4482 12.7617C13.3008 12.9199 13.1006 13 12.9004 13C12.7168 13 12.5332 12.9336 12.3887 12.7988C12.0859 12.5156 12.0693 12.041 12.3525 11.7383L13.2748 10.75H10V16.5H4.25C3.83691 16.5 3.5 16.1631 3.5 15.75Z"
          fill="#0265DC"
        />
      </svg>
    </Icon>
  );
};

export default LeftSidebarCloseIcon;
